import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import clsx from "clsx";

// styles
import useStyles from "./styles";

const ReskinningRadioGroup = ({
  data = [],
  value,
  onSelectedRadioChanged,
  labelInput = "value",
  valueInput = "key",
  wrapperClasses,
  rootCustomClasses,
  themeClass,
  ...props
}) => {
  const styles = useStyles();

  return (
    <Box
      className={clsx(styles.googleMapsWrapper, {
        [rootCustomClasses]: !!rootCustomClasses,
      })}
    >
      <FormControl
        component="fieldset"
        className={clsx(wrapperClasses, themeClass)}
      >
        <RadioGroup
          row
          value={value}
          onChange={(e) => onSelectedRadioChanged(e, e.target.value)}
        >
          {data?.map((option) => (
            <FormControlLabel
              key={option[valueInput]}
              value={option[valueInput]}
              control={
                <Radio
                  className={styles.radioRoot}
                  disableRipple
                  color="default"
                  checkedIcon={
                    <span
                      className={clsx(
                        styles.radioIcon,
                        styles.radioCheckedIcon
                      )}
                    />
                  }
                  icon={<span className={styles.radioIcon} />}
                  {...props}
                />
              }
              label={
                <span className={styles.textSmMedium}>
                  {option[labelInput]}
                </span>
              }
              className={styles.containerLableCheck}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default ReskinningRadioGroup;
